import {
  ApplicationConfig,
  provideExperimentalZonelessChangeDetection,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CONSTANTS_DETAILS } from './shared';

// This file is part of the Angular application configuration.import { MSAL_PROVIDERS, msalInitializer } from './auth/config/msal.config';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { MSAL_PROVIDERS, msalInitializer } from './auth/config/msal.config';
import { spinnerInterceptor } from './config/spinner';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const msalService = inject(MsalService);
      return msalInitializer(msalService)();
    }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([spinnerInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideExperimentalZonelessChangeDetection(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) =>
          new TranslateHttpLoader(http, './assets/translation/', '.json'),
        deps: [HttpClient],
      },
      fallbackLang: CONSTANTS_DETAILS.APP_DEFAULT_LANGUAGE,
      lang: CONSTANTS_DETAILS.APP_DEFAULT_LANGUAGE,
    }),
    // Provide the TranslateLoader using the factory service
    importProvidersFrom(MsalModule),
    MSAL_PROVIDERS.INSTANCE,
    MSAL_PROVIDERS.GUARD_CONFIG,
    MSAL_PROVIDERS.INTERCEPTOR_CONFIG,
    MSAL_PROVIDERS.INTERCEPTOR,
    ...MSAL_PROVIDERS.MSAL_SERVICE,
  ],
};
